import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError, finalize, throwError} from 'rxjs';
import {LoadingService} from '../../shared/services/loading.service';
import {Router} from '@angular/router';
import {AlertService} from '../../shared/services/alert.service';
import {AuthService} from '../../core/auth/auth.service';
import {Messages} from '../../shared/constants/messages';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService: LoadingService = inject(LoadingService);
  const alertService: AlertService = inject(AlertService);
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  const jwtToken = authService.getToken();

  loadingService.show();

  let requestToForward = req;

  if (jwtToken) {
    requestToForward = req.clone({
      headers: req.headers.set("Authorization", "Bearer " + jwtToken)
    });
  }

  return next(requestToForward).pipe(
    catchError((error: HttpErrorResponse) => {

      let errorMessage = Messages.UNEXPECTED_ERROR;

      if (error.status === 0) {
        if (!navigator.onLine) {
          router.navigate(["/offline"]);
          errorMessage = Messages.NO_INTERNET_CONNECTION;
        } else {
          errorMessage = Messages.SERVER_UNREACHABLE;
        }
      } else if (error.status === 401) {
        errorMessage = Messages.SESSION_EXPIRED;
        authService.logout();
      } else if (error.status === 403) {
        if (error.error && error.error.message === Messages.USER_NOT_ACTIVE) {
          errorMessage = Messages.USER_NOT_ACTIVE;
        } else if (error.error && error.error.message) {
          errorMessage = error.error.message;
        } else {
          errorMessage = Messages.FORBIDDEN;
        }
      } else if (error.status >= 500) {
        errorMessage = Messages.SERVER_INTERNAL_ERROR;
      } else if (error.error && error.error.message) {
        errorMessage = error.error.message;
      }

      if (error.status !== 0 || navigator.onLine) {
        if (errorMessage === Messages.USER_NOT_ACTIVE) {
          alertService.showSuccess(errorMessage);
        } else {
          alertService.showError(errorMessage);
        }
      }

      return throwError(() => error);
    }),
    finalize(() => {
      loadingService.hide();
    })
  );
};






